import isObject from "../struct-events/is-object.js";

function cloneValue(value) {
    if (isObject(value)) {
        if (Array.isArray(value)) {
            return cloneArray(value);
        } else {
            return cloneObject(value);
        }
    } else {
        return value;
    }
}

function cloneObject(object) {
    const clone = {};

    for (const key in object) {
        clone[key] = cloneValue(object[key]);
    }

    return clone;
}

function cloneArray(array) {
    return array.map(value => cloneValue(value));
}

export default cloneValue;
